module.exports = __webpack_public_path__ + "img/jifen.8e7cba60.png";